var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('v-btn',{staticClass:"mr-2",on:{"click":_vm.onCancel}},[_vm._v(_vm._s(_vm.$t("global.action.cancel")))]),_c('v-btn',{attrs:{"color":"primary","type":"submit","disabled":!_vm.canSubmit}},[_vm._v(" "+_vm._s(_vm.confirmText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }